import request from '../utils/request'

export default {
  // 获取所有用户
  findAll(params) {
    return request.get('/api/user', { params })
  },
  
  // 根据ID获取用户
  findById(id) {
    return request.get(`/api/user/${id}`)
  },
  
  // 添加用户
  add(user) {
    return request.post('/api/user', user)
  },
  
  // 更新用户
  update(id, user) {
    return request.put(`/api/user/${id}`, user)
  },

  // 更新个人中心
  updateProfile(id, formData) {
    return request({
      url: '/api/user/profile',
      method: 'post',
      data: formData
    })
  },
  
  // 删除用户
  delete(id) {
    return request.delete(`/api/user/${id}`)
  },
  
  // 批量删除
  deleteBatch(ids) {
    return request.delete('/api/user/batch', { data: ids })
  },

  // 分配组织机构
  assignOrgs(userId, orgIds) {
    return request.post(`/api/user/${userId}/orgs`, orgIds)
  },
  
  // 分配角色
  assignRoles(userId, roleIds) {
    return request.post(`/api/user/${userId}/roles`, roleIds)
  },

  // 获取当前用户信息的接口
  getCurrentUser() {
    return request.get('/api/user/current')
  },

  // 检查账号是否存在
  checkUsername(params) {
    return request.get('/api/user/checkUsername', { params })
  },

  // 重置密码
  resetPassword(userId) {
    return request.post('/api/user/resetPassword', { userId });
  },

  // 修改密码
  changePassword(params) {
    return request.post('/api/user/changePassword', params)
  }

}